
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from "firebase/analytics";


const firebaseConfig = {
  apiKey: "AIzaSyCY7DhhFim-zqC-JXgv_MF95ASxj5vlj_A",
  authDomain: "fir-app-c0b5f.firebaseapp.com",
  projectId: "fir-app-c0b5f",
  storageBucket: "fir-app-c0b5f.appspot.com",
  messagingSenderId: "996008195700",
  appId: "1:996008195700:web:6a2b625f54463a97e50321",
  measurementId: "G-LDBZTGW00Z"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const analytics = getAnalytics(app);

export default app;
